import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'hold-up-cards-banner',
    templateUrl: './hold-up-cards.component.html',
    styleUrls: ['./hold-up-cards.component.css'],
    standalone: false
})
export class HoldUpCardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
